import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Facebook, Instagram, Youtube, Globe, MapPin, Mail, Phone, Clock, MessageCircle, Stethoscope } from 'lucide-react';
export const Footer = () => {
  return <footer id="main-footer" className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-white text-lg font-semibold mb-4 flex items-center">
              <img src="/ipse-logo-white.png" alt="IPSE SA" className="h-8 w-6 mr-2" />
              IPSE S.A.
            </h3>
            <p className="text-sm mb-4">
              Potenciando empresas con soluciones de software innovadoras.
            </p>
          </div>
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Productos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/quickcont" className="text-sm hover:text-white flex items-center">
                  <img src="/quickcont-logo-white.png" alt="QuickCont" className="w-5 h-5 mr-2" />
                  <span>QuickCont</span>
                </Link>
              </li>
              <li>
                <a href="https://quickcont.ipse.com.ec" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white flex items-center">
                  <Globe className="h-5 w-5 mr-2" />
                  <span>Acceder a QuickCont</span>
                </a>
              </li>
              <li>
                <Link to="/facelec" className="text-sm hover:text-white flex items-center">
                  <img src="/facelec-logo-white.png" alt="Facelec" className="w-5 h-5 mr-2" />
                  <span>Facelec</span>
                </Link>
              </li>
              <li>
                <a href="https://facelec.ipse.com.ec" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white flex items-center">
                  <Globe className="h-5 w-5 mr-2" />
                  <span>Acceder a Facelec</span>
                </a>
              </li>
              <li>
                <Link to="/galenos" className="text-sm hover:text-white flex items-center">
                  <Stethoscope className="w-5 h-5 mr-2 text-white-600" />
                  <span>Galenos Web</span>
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Compañía</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm hover:text-white">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-white">
                  Contacto
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm hover:text-white">
                  Productos
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Mail size={16} className="mr-2 mt-0.5 flex-shrink-0 text-blue-400" />
                <div className="text-sm">
                  <div>
                    <span className="text-gray-400">Ventas:</span>
                    <a href="mailto:gerenciacomercial@ipse.com.ec" className="hover:text-white ml-2">
                      gerenciacomercial@ipse.com.ec
                    </a>
                  </div>
                  <div>
                    <span className="text-gray-400">Soporte:</span>
                    <a href="mailto:soporte@ipse.com.ec" className="hover:text-white ml-2">
                      soporte@ipse.com.ec
                    </a>
                  </div>
                </div>
              </li>
              <li className="flex items-start">
                <Phone size={16} className="mr-2 mt-0.5 flex-shrink-0 text-blue-400" />
                <div className="text-sm">
                  <div className="flex items-center gap-2">
                    <span className="text-gray-400">Ventas y Soporte:</span>
                    <a href="tel:+593979652188" className="hover:text-white">
                      +593 97 965 2188
                    </a>
                    <a href="https://wa.me/593979652188" target="_blank" rel="noopener noreferrer" className="text-green-400 hover:text-green-300">
                      <MessageCircle size={16} />
                    </a>
                  </div>
                </div>
              </li>
              <li className="flex items-start">
                <MapPin size={16} className="mr-2 mt-0.5 flex-shrink-0 text-blue-400" />
                <div className="text-sm">
                  <span className="text-gray-400">Dirección:</span>
                  <div className="ml-2">
                    <a href="https://maps.app.goo.gl/TjSiYKsU8W3VZBTf9" target="_blank" rel="noopener noreferrer" className="hover:text-white">
                      Guayaquil<br />
                      Edificio The Point, piso 18 oficina 03
                    </a>
                  </div>
                </div>
              </li>
            </ul>
            <div className="mt-4">
              <h4 className="text-white text-sm font-semibold mb-2">
                Síguenos
              </h4>
              <div className="grid grid-cols-5 gap-3">
                <a target="_blank" href="https://www.facebook.com/ipsesaec/" className="hover:text-white" aria-label="Facebook">
                  <Facebook size={18} />
                </a>
                <a target="_blank" href="https://www.instagram.com/ipsesa_ec/" className="hover:text-white" aria-label="Instagram">
                  <Instagram size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800 text-sm text-center">
          <p>
            &copy; {new Date().getFullYear()} IPSE SA. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
};